import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import axios from "axios";
import { BiDish, BiSolidDish } from "react-icons/bi";
import defaultImage from "../../../utils/DefaultImage";
import TableLoader from "../../../utils/TableLoader";
import PaginationComponent from "../../../utils/PaginationComponent";
import { IoIosArrowBack } from "react-icons/io";

const MenuView = (props) => {
    const {
        menuData,
        handleCancel,
        selectedDishes,
        editMenuDish,
    } = props;
    const [dishListData, setDishListData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;

    //===================== Pages State ===============================

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    //================================== get dishes ===================================

    const getDishListData = async () => {
        setIsLoading(true);
        try {
            const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
            const RestId = localStorage.getItem("currentRestId");
            const token = localStorage.getItem("token");
            let params;
            params = {
                pageNumber: page,
                size: rowsPerPage,
            };
            const response = await axios.get(`${apiUrl}/api/v1/restaurants/${RestId}/dishes`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                params,
            });

            const data = response?.data;
            setDishListData(data?.data);
            setTotalPages(data?.total);
        } catch (error) {
            console.error('Error fetching order data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getDishListData();
    }, [page, rowsPerPage])

    return (
        <>
            <section className="border-t border-[#D9D9D9] sm:mt-5 mt-0 pt-10">
                <h3 className="text-3xl font-bold mb-2 poppins-medium  self-start">Vista Menu</h3>
                <div className="w-full flex items-center my-5 justify-center flex-wrap">
                    <div className="w-full grid md:grid-cols-2 sm:gap-4 gap-2 mb-[18px]">
                        <div className="dropdown-main mb-3">
                            <div className="relative group w-full bg-[#FFFFFF]">
                                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                                    Nome Menu
                                </label>
                                <input
                                    type="text"
                                    className="w-full flex justify-between poppins-medium items-center px-4 py-[17px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] relative z-10 poppins-regular text-xs bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={menuData.name || ""}
                                    placeholder="Nome Menu"
                                    style={{ cursor: "not-allowed" }}
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className="dropdown-main mb-3">
                            <div className="relative group w-full bg-[#FFFFFF]">
                                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                                    Stato:
                                </label>
                                <input
                                    type="text"
                                    className="w-full flex justify-between poppins-medium items-center px-4 py-[17px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] relative z-10 poppins-regular text-xs bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={menuData.status === "active" ? "Attivo" : menuData.status === "inactive" ? "Inattivo" : ""}
                                    style={{ cursor: "not-allowed" }}
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                    <div className="w-full grid gap-4">
                        <div className="relative group w-full bg-[#FFFFFF]">
                            <div className="flex flex-col w-full gap-3">
                                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                                    Descrizione
                                </label>
                                <textarea
                                    rows="4"
                                    className="poppins-regular px-4 py-3 text-[16px]  text-[#8B8B8B] rounded-[14px]  bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                    value={menuData.description || ""}
                                    placeholder="Descrizione"
                                    style={{ cursor: "not-allowed" }}
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                {/* list of Dishes */}
                <div className="wine-main-stock w-auto h-auto bg-[#F8F8F8] border-[1.5px] border-[#8B24332B] text-[#303030] pt-3 pb-0 px-6 rounded-xl shadow">
                    <table className="w-full text-left ristoranti_table">
                        <thead>
                            <tr className="border-b">
                                <th className="pb-3 pr-2 text-left poppins-medium"></th>
                                <th className="pb-3 pr-2 text-left poppins-medium">Immagine</th>
                                <th className="pb-3 px-2 text-left poppins-medium">Nome del piatto</th>
                                <th className="pb-3 px-2 text-left poppins-medium">Descrizione</th>
                                <th className="pb-3 px-2 text-left poppins-medium">Mostra Prezzi</th>
                                <th className="pb-3 px-2 text-left poppins-medium">Prezzo Intero</th>
                                <th className="pb-3 px-2 text-left poppins-medium">Prezzo Mezza Porzione</th>
                            </tr>
                        </thead>
                        {isLoading ? (
                            <TableLoader />
                        ) : (
                            <tbody>
                                {dishListData && dishListData.length > 0 ? (
                                    dishListData.map((item, index) => {
                                        const editItem = editMenuDish.find((edit) => edit.id === item.id) || item;
                                        return (
                                            <tr key={index} className="border-b xxl:text-lg text-sm">
                                                <td className="py-4 text-left poppins-regular">
                                                    <input
                                                        type="checkbox"
                                                        className="h-4 w-4 border rounded-md accent-[#8B2433] mr-2 poppins-regular"
                                                        checked={selectedDishes.some((selectedDish) => selectedDish.id === item.id)}
                                                        readOnly
                                                        style={{ cursor: "not-allowed" }}
                                                    />
                                                </td>

                                                <td className="pr-2 py-4">
                                                    <div className="thumbnail_image rounded-lg w-[50px] h-[60px] p-1 flex align-center justify-center">
                                                        <img
                                                            className="w-10 h-10 rounded-full"
                                                            src={item?.picture ? `${logoUrl}/${item.picture}` : defaultImage}
                                                            alt="Dish"
                                                        />
                                                    </div>
                                                </td>
                                                <td className="py-4 px-2 text-left poppins-regular">{item?.name}</td>
                                                <td className="py-4 px-2 text-left poppins-regular">{item?.description}</td>
                                                <td className="py-4 px-2 text-left poppins-regular">
                                                    <div className="flex flex-col items-center justify-center gap-2">
                                                        {/* Full Price Checkbox */}
                                                        <div className="flex items-center gap-2">
                                                            <div className="svg-icon h-[15.69px] w-[15.69px] bg-white">
                                                                <BiSolidDish className="w-4 h-4" color="#303030" />
                                                            </div>
                                                            <input
                                                                type="checkbox"
                                                                className="accent-[#8B2433] w-4 h-4 rounded-md"
                                                                checked={editItem.is_option_to_be_full_dish || false}
                                                                readOnly
                                                                style={{ cursor: "not-allowed" }}
                                                            />
                                                        </div>
                                                        {/* Half Price Checkbox */}
                                                        <div className="flex items-center gap-2">
                                                            <div className="svg-icon h-[15px] w-[15px] bg-white">
                                                                <BiDish className="w-4 h-4" color="#303030" />
                                                            </div>
                                                            <input
                                                                type="checkbox"
                                                                className="accent-[#8B2433] w-4 h-4 rounded-md"
                                                                checked={editItem.is_option_to_be_half_dish || false}
                                                                readOnly
                                                                style={{ cursor: "not-allowed" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="py-4 px-2 text-left poppins-regular">
                                                    <input
                                                        type="text"
                                                        placeholder="Scrivi qui"
                                                        className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                        value={editItem.full_price || ""}
                                                        readOnly
                                                        style={{ cursor: "not-allowed" }}
                                                    />
                                                    {/* {editItem.is_option_to_be_full_dish ? (
                                                        <input
                                                            type="text"
                                                            placeholder="Scrivi qui"
                                                            className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                            value={editItem.full_price || ""}
                                                            readOnly
                                                            style={{ cursor: "not-allowed" }}
                                                        />
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                            value="0.00"
                                                            readOnly
                                                            style={{ cursor: "not-allowed" }}

                                                        />
                                                    )} */}
                                                </td>
                                                <td className="py-4 px-2 text-left poppins-regular">
                                                    <input
                                                        type="text"
                                                        placeholder="Scrivi qui"
                                                        className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                        value={editItem.half_price || ""}
                                                        readOnly
                                                        style={{ cursor: "not-allowed" }}
                                                    />
                                                    {/* {editItem.is_option_to_be_half_dish ? (
                                                        <input
                                                            type="text"
                                                            placeholder="Scrivi qui"
                                                            className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                            value={editItem.half_price || ""}
                                                            readOnly
                                                            style={{ cursor: "not-allowed" }}
                                                        />
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                                                            value="0.00"
                                                            readOnly
                                                            style={{ cursor: "not-allowed" }}
                                                        />
                                                    )} */}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="py-4 text-center">
                                            No dishes found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>

                {dishListData && dishListData?.length > 0 && (
                    <PaginationComponent
                        page={page}
                        totalPages={totalPages}
                        rowsPerPage={rowsPerPage}
                        setPage={setPage}
                        setRowsPerPage={setRowsPerPage}
                    />
                )}

                <div className="flex text-sm justify-start gap-4 mt-4">
                    <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#8B2433] text-[#8B2433] rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                        onClick={handleCancel}
                    >
                        <IoIosArrowBack size={"25px"} color="red" className="group-hover:invert" />
                        <span className="poppins-regular">Indietro</span>
                    </button>
                </div>
            </section>
        </>
    );
};

MenuView.propTypes = {
    menuData: PropTypes.object.isRequired,
    setMenuData: PropTypes.func.isRequired,
    isLoading: PropTypes.object.isRequired,
    setIsLoading: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
};
export default MenuView;